import React from 'react'
import PropTypes from 'prop-types'

import { Box, Typography } from '@mui/material'

const ContainerColor = ({ containerColor = {}, ...rest }) => {
  const { color, name = '' } = containerColor

  return (
    <Box display="flex" alignItems="center" gap={1} {...rest}>
      {color && <Box minWidth={24} height={24} border="1px solid" borderColor="divider" borderRadius={1} bgcolor={color} />}
      <Typography noWrap>{name}</Typography>
    </Box>
  )
}

ContainerColor.propTypes = {
  containerColor: PropTypes.object,
}

export default ContainerColor
